import React, {useEffect, useState} from "react";
import Header from "../Header";
import Topbar from "../Topbar";
import {Outlet, useNavigate} from "react-router-dom";

import {useAuth} from "oidc-react";
import {useJwt} from "react-jwt";
// import { HubConnectionBuilder } from "@microsoft/signalr";
const BasicLayout = ({admin, adminData}) => {
    const {userData, isLoading} = useAuth();
    const token = userData?.access_token;
    const {decodedToken, isExpired} = useJwt(token);
    const userName = decodedToken?.name;
    const navigate = useNavigate();
    const [userCount, setUserCount] = useState(0);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        if (!userData && !isLoading) {
            navigate('/login');
        }
    }, [userData, isLoading]);
    return (
        <div className="flex min-h-screen">
            <Header admin={admin} adminData={adminData} userName={userName}/>
            <main className="flex-1 min-w-0 overflow-auto pt-14 sm:pt-0 flex flex-col bg-[#F7F8FB]">
                <Topbar adminData={adminData}/>
                <div className="flex-1">
                    <Outlet/>
                </div>
            </main>
        </div>
    );
};

export default BasicLayout;
